/** One-sentence inclusion rules for Jobs / Pipeline buckets. Ready ≡ Inbox. */
export const JOB_BUCKET_GLOSSARY = {
  inbox:
    "Jobs with no pipeline that are not no-go or archived — ready to Start or No-go.",
  ready:
    "Jobs with no pipeline that are not no-go or archived — same set as Jobs Inbox.",
  active: "Jobs with an active (non-archived) pipeline.",
  archived: "Jobs whose pipeline has been archived.",
  nogo: "Unpiped jobs marked no-go or archived without a pipeline.",
  pipeline: "Jobs currently in an active pipeline (same as Active).",
} as const;

export type JobBucketGlossaryKey = keyof typeof JOB_BUCKET_GLOSSARY;
